import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../lib/net";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class PMS_Bevak extends React.Component {
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = { pgid: 11, tra: [] };
    this.state.seldate = new Date();
    this.state.avd = "01";
    this.state.rca = [];
    this.state.kro = {};
    this.state.aa = [
                {id: '01', text: 'AVD 01'},
                {id: '02', text: 'AVD 02'}
            ];
    this.state.cols = {};
    //context.posrend = this;
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.bevak();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }

  kund_open(row) {
      var self = this;
  }
  kund_edit(row) {
      var self = this;
      //alert(JSON.stringify(row.krr00));
        this.setState({edit: 1, kro: row});
  }
  fkn_close() {
    this.setState({edit: false });
    //this.props.history.push("cas");
    //this.login_srv(uid, pwd);
  }

  bevak() {
    var self = this;
    var prm = {};
    prm.req = "pms.log.qs_logs";
    prm.typ = "0";
    //prm.avd = this.state.avd;

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        var o = {};
        //o.deps = ret.rco;
        //alert(JSON.stringify(o));
        self.setState({rca: ret.rco }, function () {
            self.syncCols("rcaTable");
        });
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e) {
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }
  cssCols = function (cid) {
      var css = {};
      if(this.state.cols[cid]) css.width = this.state.cols[cid].toString() + "px";
      //if(cid == "c01") alert(JSON.stringify(this.state.cols[cid]));
      return css;
  }
  syncCols = function (tb) {

    if (!document.getElementById(tb)) return;

    var cols = {};
    var ix = document.getElementById(tb).rows.length - 1;
    var ic = document.getElementById(tb).rows[0].cells.length;
    var ci = 0;
    while(ci < ic) {
        var cxi = ci + 1;
        var col = "c" + cxi.toString().padStart(2, "0");
        cols[col] = document.getElementById(tb).rows[ix].cells[ci].clientWidth + 1;
        ci = ci + 1;
    }
    this.setState({cols: cols });
    //alert(JSON.stringify(this.state.cols));
    //this.forceUpdate();
  };

  render() {
    return (
    <div className="web-app">
    <div className="flex-row flex-space-between">
        <div className="flex-row flex">
        <button className="btn btn-hw-blue w150 ripple" onClick={() => this.syncCols("kidTable") } aria-label="System" >
            FUNKTIONER
        </button>
        </div>
        <div className="flex-row">
       </div>
        <div className="flex-row flex-end flex">
        <button className="btn btn-hw-blue w150 ripple" onClick={() => this.syncCols("kidTable") } aria-label="System" >
            UPPDATERA
        </button>
        </div>
    </div>
    <div className="divider_orange"></div>

    <div className="web-col">
        <table className="table table-bordered table-hover tb " style={{marginBottom: "0px"}}>
            <thead>
            <tr>
                <th style={ this.cssCols("c01" ) }>Löpnr</th>
                <th style={ this.cssCols("c02" ) }>Rumsnr</th>
                <th style={ this.cssCols("c03" ) }>Tid</th>
                <th style={ this.cssCols("c04" ) }>Text</th>
                <th style={ this.cssCols("c05" ) }>Signatur</th>
                <th style={ this.cssCols("c06" ) }>Utlämnad</th>
                <th style={ this.cssCols("c07" ) }>Signatur</th>
                <th style={ this.cssCols("c08" ) }></th>
                <th style={{width:"16px"}} ></th>
            </tr>
            </thead>
        </table>
       <div className="tb-cdi" style={ this.tb_style() }>
       <table id="rcaTable" className="table table-bordered table-hover tb">
            <tbody>
            { this.state.rca.map((row, key) =>
            <tr key={key} id={ row.r0lopnr } onDoubleClick={() => this.kund_edit(row) }>
                <td>{ row.r0lopnr }</td>
                <td>{ row.r0rumsnr }</td>
                <td>{ row.r0tid }</td>
                <td>{ row.r0text }</td>
                <td>{ row.r0sign }</td>
                <td>{ row.r0givenout }</td>
                <td>{ row.r0sign1 }</td>
                <td style={{width:"40px",cursor:"pointer"}} onClick={() => this.kund_edit(row) }><i className="fa fa-cog text-danger"></i></td>
            </tr>
            )}
            <tr style={{visibility: "hidden"}}>
				<th>Löpnr</th>
				<th>Rumsnr</th>
				<th>Tid</th>
				<th>Text</th>
				<th>Signatur</th>
				<th>Utlämnad</th>
				<th>Signatur</th>
                <th></th>
            </tr>
            </tbody>
        </table>
        </div>
    </div>
   </div>
  );
    }
}
export default PMS_Bevak;
